import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { updateFormProperties } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { TableRow } from 'apps/auth/components/common/components/TableRow/TableRow';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { Row } from 'apps/auth/components/common/Layout/Row';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import FeeTextPopup from 'apps/auth/components/common/send/popups/FeeTextPopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import { FROM_ACCOUNT, PAYMENT_METHOD } from 'apps/auth/constants/fieldsName';
import { AUTH_REQUEST_PAY_ACTION } from 'apps/auth/constants/UrlConstants';
import { USA } from 'apps/auth/constants/WellKnownCountries';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { resolveArguments, toLowerCase } from 'apps/auth/helpers/utils';
import { useApp, useAuth, useExtra, useFields, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';
import { CheckService } from 'apps/auth/services/CheckService';

import GooglePaySendButton from '../googlePay/GooglePaySendButton';

const PayPrecheckPopup = (props) => {
    const { country } = useApp();
    const { countryId: userCountry } = useAuth();
    const { lang } = useLanguage();
    const { precheck, commission } = useExtra();
    const fields = useFields(props.formName);
    const {
        comment,
        description,
        usaNotRecipt,
        requestPayPrecheckTo,
        requestPayPrecheckFrom,
        requestPayPrecheckUsaFee,
        requestPayPrecheckFee,
        requestPayPrecheckTotal,
        requestPayPrecheckUsaFxrate,
        requestPayPrecheckFxrate,
        termsOfUseCode,
        requestPayPrecheckFooter,
        requestPayPrecheckRecipientToBlock,
        precheckAgreeButton,
        requestPayPrecheckAmountToBlock,
        paymentOptionText,
        transferToCard,
        requestPayPrecheckPromocode,
        deliveryMethod,
    } = usePageMessages();

    const feeAmount = commission?.fee;
    const fromIso = commission?.restrictionFrom?.ccyIso;
    const toIso = commission?.restrictionTo?.ccyIso;
    const paymentMethod = fields[PAYMENT_METHOD]?.value;
    const accountFrom = fields[FROM_ACCOUNT]?.value;
    const accountFromLastDig = typeof accountFrom === 'string' && accountFrom.length > 0 ? accountFrom.slice(-4) : '';
    const account = precheck?.accountFrom?.length > 0 ? precheck.accountFrom : ` ${accountFromLastDig}`;

    const payAgree = (e) => {
        e.preventDefault();
        if (props.submitRef && props.submitRef.current) {
            props.updateFormProperties(props.formName, AUTH_REQUEST_PAY_ACTION).then(() => {
                props.popupRef?.current?.close();
                props.submitRef.current.click();
            });
        }
    };

    const getAvatar = () => {
        if (precheck.avatar) {
            return precheck.avatar;
        } else {
            return null;
        }
    };

    const getLetter = () => {
        if (precheck.avatar) {
            return null;
        } else if (precheck.firstLetter) {
            return precheck.firstLetter;
        } else {
            return ':)';
        }
    };
    const precheckPopupButtons = (
        <>{precheck?.fromGooglePay ? <GooglePaySendButton /> : <Button type="button" caption={precheckAgreeButton} onClick={payAgree} raised={true} />}</>
    );

    return (
        <ComplexPopup popupRef={props.popupRef} precheckPopupButtons={precheckPopupButtons}>
            <Row textAlign="center">
                {userCountry === USA && (
                    <Text variant="div" size="secondary" indent="adaptive-24-32">
                        {usaNotRecipt}
                    </Text>
                )}
                <Row indent="adaptive-16-24">
                    <DiskBadge src={getAvatar()} diskText={getLetter()} diskSize="large" flagName={precheck.toBankCountryCode} />
                </Row>
                <Text variant="div" indent="4px" ellipsis>
                    {resolveArguments(requestPayPrecheckTo, precheck.accountTo)}
                </Text>
                <Row indent={!precheck.comment ? 'adaptive-24-32' : 'adaptive-8-16'}>
                    <Text size="header">
                        {`${precheck.formatedAmountFrom} `}
                        <Text size="header" smallCaps>
                            {toLowerCase(fromIso)}
                        </Text>
                    </Text>
                    <Text size="header">{' → '}</Text>
                    <Text size="header">
                        {`${precheck.formatedAmountTo} `}
                        <Text size="header" smallCaps>
                            {toLowerCase(toIso)}
                        </Text>
                    </Text>
                </Row>
                {precheck.comment && (
                    <Text variant="div" color="secondary" indent="adaptive-8-16">
                        {precheck.comment}
                    </Text>
                )}
            </Row>
            <TableContainer indent="48px">
                {userCountry === USA && (
                    <TableRow title={requestPayPrecheckFrom} pseudoTable>
                        {precheck.formatedAmountFromWithoutFee}
                        <Text size="secondary" smallCaps>
                            {' ' + toLowerCase(fromIso)}
                        </Text>
                    </TableRow>
                )}
                <TableRow title={userCountry === USA ? requestPayPrecheckUsaFee : requestPayPrecheckFee} pseudoTable>
                    {resolveArguments(precheck.commission, [getLocalizedRawAmount(lang, country, feeAmount), fromIso])}
                </TableRow>
                {precheck.promoCode && (
                    <TableRow title={requestPayPrecheckPromocode} pseudoTable>
                        {precheck.promoCode}
                    </TableRow>
                )}
                {userCountry === USA && (
                    <TableRow title={requestPayPrecheckTotal} pseudoTable>
                        {precheck.formatedAmountFrom}
                        <Text size="secondary" smallCaps>
                            {' ' + toLowerCase(fromIso)}
                        </Text>
                    </TableRow>
                )}
                {precheck.exchangeRate && (
                    <TableRow title={userCountry === USA ? requestPayPrecheckUsaFxrate : requestPayPrecheckFxrate} pseudoTable>
                        {precheck.exchangeRate}
                    </TableRow>
                )}
                {userCountry === USA && (
                    <TableRow title={requestPayPrecheckAmountToBlock} pseudoTable>
                        {precheck.amountTo}
                        <Text size="secondary" smallCaps>
                            {' ' + toLowerCase(toIso)}
                        </Text>
                    </TableRow>
                )}
                <TableRow title={requestPayPrecheckRecipientToBlock} pseudoTable>
                    {precheck.accountTo}
                </TableRow>
                {description && description.indexOf(':') !== -1 && (
                    <TableRow title={description.split(':')[0]} pseudoTable>
                        {description.split(':')[1]}
                        {comment && (
                            <DiskButton
                                type="button"
                                variant="tertiary"
                                iconName="info-rounded"
                                size="small"
                                marginRight="-8px"
                                marginTop="-4px"
                                raised={false}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (comment) {
                                        props.popupRef.current?.open(
                                            <FeeTextPopup
                                                countryToId={precheck.toBankCountryCode}
                                                text={comment}
                                                deliveryMethod={deliveryMethod}
                                                closeHandler={props.handleClose}
                                                isComment={true}
                                                isShowTerms={true}
                                            />,
                                        );
                                    }
                                }}
                            />
                        )}
                    </TableRow>
                )}
                {precheck?.accountFrom && precheck.accountFrom?.length > 0 && (
                    <TableRow title={paymentOptionText} pseudoTable>
                        {CheckService.getFormattedPaymentAccount({ transferToCard }, paymentMethod, userCountry, account)}
                    </TableRow>
                )}
            </TableContainer>
            {description && description.indexOf(':') === -1 && (
                <Text variant="div" size="secondary" textAlign="center" indent="adaptive-8-16">
                    {description}
                </Text>
            )}
            {userCountry === USA && (
                <Text variant="div" size="secondary" textAlign="center" indent="adaptive-8-16">
                    {requestPayPrecheckFooter}
                </Text>
            )}
            {userCountry !== USA && (
                <Text variant="div" size="secondary" textAlign="center">
                    <DangerouslyHtml
                        type="text"
                        size="secondary"
                        dangerouslyHtml={resolveArguments(termsOfUseCode, precheck.termsOfUseParams ? precheck.termsOfUseParams.split(';') : null)}
                    />
                </Text>
            )}
        </ComplexPopup>
    );
};

PayPrecheckPopup.propTypes = {
    formName: PropTypes.string,
    submitRef: PropTypes.any,
};

export default connect(null, {
    updateFormProperties,
})(PayPrecheckPopup);
